import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import EventModel from '../EventModel';

/**
 * Represents SearchQueryEventModel
 */
export default class SearchQueryEventModel extends EventModel {
	public search_term: string;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		const search_term = data.search_term;

		this.search_term = search_term || '';
	}
};
